exports.REGISTRY_ITEMS = {
	applications: Object.freeze({
		app_iprf: Object.freeze({
			id: "app_iprf",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immoweb.be/assets/apps/iprf/v1/server/remoteEntry.js",
				client: "https://www.immoweb.be/assets/apps/iprf/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze([
					"/en/property-developer/*",
					"/en/notary/*",
					"/en/agency/*",
					"/fr/promoteur-immobilier/*",
					"/fr/notaire/*",
					"/fr/agence/*",
					"/nl/vastgoedontwikkelaar/*",
					"/nl/notaris/*",
					"/nl/agentschap/*",
				]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_iprf"),
		}),
		app_home_main: Object.freeze({
			id: "app_home_main",
			authorization: "any",
			microFrontends: Object.freeze({
				mfe_avis_agencyInTheSpotlight: Object.freeze({
					client: "https://www.immoweb.be/assets/mfes/avis_agencyInTheSpotlight/v1/client/remoteEntry.js",
				}),
			}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immoweb.be/assets/apps/home_main/v2/server/remoteEntry.js",
				client: "https://www.immoweb.be/assets/apps/home_main/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/fr/", "/en/", "/nl/"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_home_main"),
		}),
	}),
	microFrontends: Object.freeze({
		mfe_avis_agencyInTheSpotlight: Object.freeze({
			id: "mfe_avis_agencyInTheSpotlight",
			type: "micro_frontend",
			rendering: "client",
			version: 1,
			urls: Object.freeze({
				client: "https://www.immoweb.be/assets/mfes/avis_agencyInTheSpotlight/v1/client/remoteEntry.js",
			}),
		}),
	}),
};
